import {Route, Routes} from "react-router-dom";
import List from "./List";
import Detail from "./Detail";
import Post from "./Post";
import Edit from "./Edit";
import {RouterProps} from "../../../RouterProps";

export default function ReasonRouter(props: RouterProps) {
    return <>
        <Routes>
            <Route path={'/'} element={<List {...props} />} />
            <Route path={'/post'} element={<Post {...props} />} />
            <Route path={'/:userWithdrawalReasonId'} element={<Detail {...props} />} />
            <Route path={'/:userWithdrawalReasonId/edit'} element={<Edit {...props} />} />
        </Routes>
    </>
}